import { useState, useCallback } from 'react';
import { getMappedInDirections } from '../services/mappedInDirectionsService';

export const useMappedInDirections = (userId = null) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [directionsData, setDirectionsData] = useState(null);

  const fetchDirections = useCallback(async (externalId, spaceName, startLocationId, startLocationName) => {
    if (!spaceName) {
      setError('Space name is required');
      return null;
    }

    try {
      setIsLoading(true);
      setError(null);

      console.log('🗺️ Fetching directions for:', spaceName);
      console.log('🗺️ Using userId:', userId);
      const result = await getMappedInDirections(externalId,
        userId,
        spaceName,
        startLocationId,
        startLocationName);



      if (result.success) {
        setDirectionsData(result);
        console.log('✅ Directions fetched successfully');
        return result;
      } else {
        setError(result.error || 'Failed to fetch directions');
        return null;
      }
    } catch (err) {
      console.error('❌ Error fetching directions:', err);
      setError(err.message || 'Failed to fetch directions');
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  const clearDirections = useCallback(() => {
    setDirectionsData(null);
    setError(null);
  }, []);

  return {
    isLoading,
    error,
    directionsData,
    fetchDirections,
    clearDirections
  };
};